import React, { useState } from 'react'

import PropTypes from 'prop-types'

import ROIButton from './roi-button'
import './formula5k.css'

const Formula5k = (props) => {
  const [isVisible, setIsVisible] = useState(false)
  return (
    <div className="formula5k-container10">
      {isVisible === false && (
        <div className="formula5k-container11">
          <div className="formula5k-thq-formula-elm1">
            <div className="formula5k-thq-container-elm1">
              <span className="formula_blue">{props.text}</span>
              <div className="formula5k-container12">
                <span className="formula_text">{props.text10}</span>
                <span className="formula_paragraph">{props.text11}</span>
              </div>
            </div>
            <img
              alt={props.imageAlt5}
              src={props.imageSrc4}
              className="formula_arrow"
            />
            <div className="formula5k-thq-container-elm2">
              <span className="formula_blue">{props.text1}</span>
              <div className="formula5k-container13">
                <span className="formula_text">{props.text12}</span>
                <span className="formula_paragraph">{props.text13}</span>
              </div>
            </div>
            <img
              alt={props.imageAlt12}
              src={props.imageSrc12}
              className="formula_arrow"
            />
            <div className="formula5k-thq-container-elm3">
              <span className="formula_blue">{props.text2}</span>
              <div className="formula5k-container14">
                <span className="formula_text">{props.text14}</span>
                <span className="formula_paragraph">{props.text15}</span>
              </div>
              <p
                onTouchEnd={() => setIsVisible(false)}
                onMouseEnter={() => setIsVisible(true)}
                onMouseLeave={() => setIsVisible(false)}
                onTouchStart={() => setIsVisible(true)}
                className="formula_button formula5k-thq-caption-elm1"
              >
                {props.caption22}
              </p>
            </div>
            <img
              alt={props.imageAlt22}
              src={props.imageSrc22}
              className="formula_arrow"
            />
            <div className="formula5k-container15">
              <span className="formula_blue">{props.text3}</span>
              <div className="formula5k-container16">
                <span className="formula_text">{props.text16}</span>
                <span className="formula_paragraph">{props.text17}</span>
              </div>
            </div>
            <img
              alt={props.imageAlt3}
              src={props.imageSrc3}
              className="formula_x"
            />
            <div className="formula5k-container17">
              <span className="formula_blue">{props.text4}</span>
              <div className="formula5k-container18">
                <span className="formula_text">{props.text18}</span>
                <span className="formula_paragraph">{props.text19}</span>
              </div>
              <span className="formula5k-text25 paragraph">{props.text5}</span>
            </div>
            <img
              alt={props.imageAlt13}
              src={props.imageSrc11}
              className="formula_arrow"
            />
            <div className="formula5k-container19">
              <span className="formula5k-text26 formula_blue">
                <span>
                  that&apos;s
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <span>€2.75M</span>
                <span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </span>
              <div className="formula5k-container20">
                <span className="formula_text">{props.text20}</span>
                <span className="formula_paragraph">{props.text21}</span>
              </div>
            </div>
          </div>
          <div className="formula5k-thq-roi-elm1">
            <ROIButton rootClassName="roi-buttonroot-class-name"></ROIButton>
            <div className="formula5k-container21">
              <div className="formula5k-container22">
                <img
                  alt={props.imageAlt41}
                  src={props.imageSrc42}
                  className="formula5k-image3"
                />
                <p className="formula5k-thq-caption-elm2 formula_text">
                  <span>
                    €550 for every €1 spent
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <br></br>
                </p>
              </div>
              <div className="formula5k-container23">
                <img
                  alt={props.imageAlt21}
                  src={props.imageSrc21}
                  className="formula5k-image4"
                />
                <p className="formula5k-thq-caption-elm3 formula_text">
                  {props.caption32}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
      {isVisible === true && (
        <div className="formula5k-thq-container-elm4">
          <div className="formula5k-thq-formula-elm2">
            <div className="formula5k-thq-container-elm5">
              <span className="formula_blue">{props.text30}</span>
              <div className="formula5k-container24">
                <span className="formula_text">{props.text101}</span>
                <span className="formula_paragraph">{props.text111}</span>
              </div>
            </div>
            <img
              alt={props.imageAlt42}
              src={props.imageSrc43}
              className="formula_arrow"
            />
            <div className="formula5k-thq-container-elm6">
              <span className="formula_blue">{props.text110}</span>
              <div className="formula5k-container25">
                <span className="formula_text">{props.text121}</span>
                <span className="formula_paragraph">{props.text131}</span>
              </div>
            </div>
            <img
              alt={props.imageAlt112}
              src={props.imageSrc112}
              className="formula_arrow"
            />
            <div className="formula5k-thq-container-elm7">
              <span className="formula5k-text40 formula_blue">
                {props.text210}
              </span>
              <div className="formula5k-container26">
                <span className="formula_text">{props.text141}</span>
                <span className="formula_paragraph">{props.text151}</span>
              </div>
              <p
                onTouchEnd={() => setIsVisible(false)}
                onMouseLeave={() => setIsVisible(false)}
                onTouchStart={() => setIsVisible(false)}
                className="formula5k-thq-caption-elm4 formula_button"
              >
                {props.caption211}
              </p>
            </div>
            <img
              alt={props.imageAlt211}
              src={props.imageSrc211}
              className="formula_arrow"
            />
            <div className="formula5k-container27">
              <span className="formula5k-text43 formula_blue">
                {props.text31}
              </span>
              <div className="formula5k-container28">
                <span className="formula_text">{props.text161}</span>
                <span className="formula_paragraph">{props.text171}</span>
              </div>
            </div>
            <img
              alt={props.imageAlt81}
              src={props.imageSrc81}
              className="formula_x"
            />
            <div className="formula5k-container29">
              <span className="formula5k-text46 formula_blue">
                {props.text41}
              </span>
              <div className="formula5k-container30">
                <span className="formula_text">{props.text181}</span>
                <span className="formula_paragraph">{props.text191}</span>
              </div>
              <span className="formula5k-text49 paragraph">{props.text51}</span>
            </div>
            <img
              alt={props.imageAlt111}
              src={props.imageSrc111}
              className="formula_arrow"
            />
            <div className="formula5k-container31">
              <span className="formula5k-text50 formula_blue">
                <span>
                  that&apos;s
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <span>€165K</span>
              </span>
              <div className="formula5k-container32">
                <span className="formula_text">{props.text201}</span>
                <span className="formula_paragraph">{props.text211}</span>
              </div>
            </div>
          </div>
          <div className="formula5k-thq-roi-elm2">
            <ROIButton rootClassName="roi-buttonroot-class-name1"></ROIButton>
            <div className="formula5k-container33">
              <div className="formula5k-container34">
                <img
                  alt={props.imageAlt411}
                  src={props.imageSrc411}
                  className="formula5k-image7"
                />
                <p className="formula5k-thq-caption-elm5 formula_text">
                  <span>
                    €33 for every €1 spent
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <br></br>
                </p>
              </div>
              <div className="formula5k-container35">
                <img
                  alt={props.imageAlt511}
                  src={props.imageSrc511}
                  className="formula5k-image8"
                />
                <p className="formula5k-thq-caption-elm6 formula_text">
                  {props.caption311}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

Formula5k.defaultProps = {
  text18: 'average tourist spend',
  text111: 'for becoming an Ambassador for @Romania',
  text4: 'multiplied by €550 per tourist',
  imageAlt3: 'image',
  imageSrc12: '/formula/arrow_black.svg',
  text20: 'to the economy',
  text51: 'according to the Ministry of Economy, Entrepreneurship and Tourism',
  imageSrc111: '/formula/arrow_black.svg',
  imageAlt22: 'image',
  imageSrc3: '/formula/x_black.svg',
  text3: 'we bring 5,000 tourists',
  text19: 'according to the Ministry of Economy, Entrepreneurship and Tourism',
  text151: 'text here',
  imageAlt12: 'image',
  caption32: '54900% return',
  text: 'your €5,000',
  imageAlt42: 'image',
  text181: 'adjusted tourist spend',
  text101: 'contribution',
  imageSrc22: '/formula/arrow_black.svg',
  imageSrc112: '/formula/arrow_black.svg',
  text41: 'multiplied by €330 per tourist',
  text1: 'helps us reach 5M people',
  text31: 'we bring 500 tourists',
  text16: 'at €1 per tourist',
  text13: 'the average CPM on social media is around €8',
  text21: 'outside money brought and spent in Romania as a result',
  imageAlt211: 'image',
  imageAlt5: 'image',
  imageAlt13: 'image',
  imageAlt511: 'image',
  imageSrc211: '/formula/arrow_black.svg',
  caption311: '3200% return',
  text11: 'for becoming an Ambassador for @Romania',
  text210: 'if only 1 in 10,000 becomes a tourist',
  imageAlt81: 'image',
  text15: 'text here',
  text17: 'average cost in Europe is €238 per tourist according to WTTC',
  text30: 'your €5,000',
  text12: 'at €1 CPM',
  text161: 'at €10 per tourist',
  imageSrc511: '/formula/roi_purple.svg',
  imageAlt411: 'image',
  text2: 'if 1 in 1,000 becomes a tourist',
  imageAlt111: 'image',
  text14: 'text here',
  imageSrc81: '/formula/x_black.svg',
  imageSrc42: '/formula/roi_black.svg',
  text201: 'to the economy',
  text10: 'contribution',
  imageSrc43: '/formula/arrow_black.svg',
  text131: 'the average CPM on social media is around €8',
  imageSrc4: '/formula/arrow_black.svg',
  text141: 'text here',
  text110: 'helps us reach 5M people',
  text121: 'at €1 CPM',
  caption22: "I don't agree",
  imageAlt41: 'image',
  text171: 'average cost in Europe is €238 per tourist according to WTTC',
  imageSrc411: '/formula/roi_black.svg',
  text191:
    'the average tourist spend for foreign trips in Europe is €806 according to Eurostat',
  imageSrc21: '/formula/roi_blue2.svg',
  text211: 'outside money brought and spent in Romania as a result',
  imageAlt21: 'image',
  caption211: 'How about now?',
  text5: 'according to the Ministry of Economy, Entrepreneurship and Tourism',
  imageAlt112: 'image',
  imageSrc11: '/formula/arrow_black.svg',
}

Formula5k.propTypes = {
  text18: PropTypes.string,
  text111: PropTypes.string,
  text4: PropTypes.string,
  imageAlt3: PropTypes.string,
  imageSrc12: PropTypes.string,
  text20: PropTypes.string,
  text51: PropTypes.string,
  imageSrc111: PropTypes.string,
  imageAlt22: PropTypes.string,
  imageSrc3: PropTypes.string,
  text3: PropTypes.string,
  text19: PropTypes.string,
  text151: PropTypes.string,
  imageAlt12: PropTypes.string,
  caption32: PropTypes.string,
  text: PropTypes.string,
  imageAlt42: PropTypes.string,
  text181: PropTypes.string,
  text101: PropTypes.string,
  imageSrc22: PropTypes.string,
  imageSrc112: PropTypes.string,
  text41: PropTypes.string,
  text1: PropTypes.string,
  text31: PropTypes.string,
  text16: PropTypes.string,
  text13: PropTypes.string,
  text21: PropTypes.string,
  imageAlt211: PropTypes.string,
  imageAlt5: PropTypes.string,
  imageAlt13: PropTypes.string,
  imageAlt511: PropTypes.string,
  imageSrc211: PropTypes.string,
  caption311: PropTypes.string,
  text11: PropTypes.string,
  text210: PropTypes.string,
  imageAlt81: PropTypes.string,
  text15: PropTypes.string,
  text17: PropTypes.string,
  text30: PropTypes.string,
  text12: PropTypes.string,
  text161: PropTypes.string,
  imageSrc511: PropTypes.string,
  imageAlt411: PropTypes.string,
  text2: PropTypes.string,
  imageAlt111: PropTypes.string,
  text14: PropTypes.string,
  imageSrc81: PropTypes.string,
  imageSrc42: PropTypes.string,
  text201: PropTypes.string,
  text10: PropTypes.string,
  imageSrc43: PropTypes.string,
  text131: PropTypes.string,
  imageSrc4: PropTypes.string,
  text141: PropTypes.string,
  text110: PropTypes.string,
  text121: PropTypes.string,
  caption22: PropTypes.string,
  imageAlt41: PropTypes.string,
  text171: PropTypes.string,
  imageSrc411: PropTypes.string,
  text191: PropTypes.string,
  imageSrc21: PropTypes.string,
  text211: PropTypes.string,
  imageAlt21: PropTypes.string,
  caption211: PropTypes.string,
  text5: PropTypes.string,
  imageAlt112: PropTypes.string,
  imageSrc11: PropTypes.string,
}

export default Formula5k
